import { IDefineCommand } from 'core-ts-types';
import { IAPCourseSearchDatasource } from '../datasources/ap_course_search_datasource';

angular
  .module('capability-ng-academic-planner')
  .service(
    'apGetCourseSearchCommand',
    function apGetCourseSearchCommand(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngAPCourseSearchDatasource: IAPCourseSearchDatasource,
      log: any
    ) {
      return defineCommandORM('apGetCourseSearchCommand', (deferred, query: string, fields: string = 'ALL') => {
        $http
          .get(`academicplan/course/search`, {
            params: {
              query,
              fields
            }
          })
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngAPCourseSearchDatasource.clear().write(data);
            deferred.resolve(data);
          })
          .catch((e: string) => {
            log.issue('course search api fetch failed');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_search/course_search/commands/ap_course_search_command.ts